import { extendTailwindMerge, validators } from "tailwind-merge";
const range = (n) => Array.from({ length: n }, (_, i) => String(i + 1));
/**
 * `tailwind-merge`, taught about this library's Tailwind v3 setup.
 *
 * **Custom type scale.** `text-display-{1..11}` and `text-rich-{1..7}` are
 * font-SIZE utilities, but tailwind-merge's default config reads any
 * unrecognised `text-*` as a text COLOUR — so `twMerge('text-display-10
 * text-white')` silently drops `text-display-10`, leaving the element with no
 * font size. Registering them under `font-size` fixes that while keeping
 * size-vs-size dedup and consumer overrides working.
 *
 * **Bare `outline`.** tailwind-merge 3 targets Tailwind v4, where `outline`
 * sets a *width*; in v3 it sets `outline-style: solid`. Left alone, it is
 * treated as conflicting with `outline-2` and dropped — leaving focus rings
 * with a width and colour but no style, which renders nothing at all. Moving it
 * back to `outline-style` keeps `outline outline-2` intact.
 *
 * Use this instead of raw `twMerge` everywhere in the library.
 */
export const cn = extendTailwindMerge({
    override: {
        classGroups: {
            "outline-style": [
                {
                    outline: [
                        "",
                        "solid",
                        "dashed",
                        "dotted",
                        "double",
                        "none",
                        "hidden",
                    ],
                },
            ],
            "outline-w": [
                {
                    outline: [
                        validators.isNumber,
                        validators.isArbitraryVariableLength,
                        validators.isArbitraryLength,
                    ],
                },
            ],
        },
    },
    extend: {
        classGroups: {
            "font-size": [{ text: [{ display: range(11), rich: range(7) }] }],
        },
    },
});
